import {
  strAlignHorizontalLeft24,
  strAlignHorizontalRight24,
  strAlignVerticalTop24,
  strAlignVerticalBottom24,
  strAlignVerticalCenter24,
  strAlignHorizontalCenter24,
  strCrop24,
} from '../carbon-icons';

export type ContextControlNodeType = {
  id: string;
  label: string;
  icon: unknown;
  class: string;
  hideLabel: boolean;
  x: number;
  y: number;
};

export const nodes: ContextControlNodeType[] = [
  {
    id: `align-left-control`,
    label: 'align-left',
    icon: strAlignHorizontalLeft24,
    class: 'custom-shape-control',
    hideLabel: true,
    x: 0,
    y: 0,
  },
  {
    id: `align-right-control`,
    label: 'align-right',
    icon: strAlignHorizontalRight24,
    class: 'custom-shape-control',
    hideLabel: true,
    x: 0,
    y: 0,
  },
  {
    id: `align-top-control`,
    label: 'align-top',
    icon: strAlignVerticalTop24,
    class: 'custom-shape-control',
    hideLabel: true,
    x: 0,
    y: 0,
  },
  {
    id: `align-bottom-control`,
    label: 'align-bottom',
    icon: strAlignVerticalBottom24,
    class: 'custom-shape-control',
    hideLabel: true,
    x: 0,
    y: 0,
  },
  {
    id: `align-v-center-control`,
    label: 'vertical-center-align',
    icon: strAlignVerticalCenter24,
    class: 'custom-shape-control',
    hideLabel: true,
    x: 0,
    y: 0,
  },
  {
    id: `align-h-center-control`,
    label: 'horizontal-center-align',
    icon: strAlignHorizontalCenter24,
    class: 'custom-shape-control',
    hideLabel: true,
    x: 0,
    y: 0,
  },
  {
    id: `crop-control`,
    label: 'crop',
    icon: strCrop24,
    class: 'custom-shape-control',
    hideLabel: true,
    x: 0,
    y: 0,
  },
];
